import React from 'react'

type Props= {
    size?: number,
    color?: string,
    colors?: string,
    strokeWidth?: number,
}
function SiteOffline({size = 16, color ="#A5A8A9", colors="#A5A8A9", strokeWidth=1.4}: Props) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3753 9.66602H14.6663V11.8327M6.99968 9.66602H1.33301V13.9993H7.99967H11.333" stroke="#FB462E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1.33301 9.66628L2.17274 5.66615L2.25305 5.28354M14.6663 9.66628L13.0065 1.66602H4.99968" stroke="#FB462E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.33301 11.834H8.99967" stroke="#FB462E" stroke-width="1.2" stroke-linecap="round" />
            <path d="M2 2L14 14" stroke="#FB462E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default SiteOffline